import { Button, Input } from "common/src/styles";
import React from "react";
import { PayoutTokenDropdown } from "./PayoutTokenDropdown";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function EmptyCart() {
  return /*#__PURE__*/_jsxs("div", {
    className: "grow block px-[16px] py-4 rounded-lg shadow-lg bg-white border border-violet-400",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex flex-col md:flex-row justify-between border-b-2 pb-2 gap-3",
      children: [/*#__PURE__*/_jsx("div", {
        className: "basis-[28%]",
        children: /*#__PURE__*/_jsx("h2", {
          className: "mt-2 text-xl",
          children: "Projects"
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex justify-end flex-row gap-2 basis-[72%]",
        children: [/*#__PURE__*/_jsx("p", {
          className: "mt-4 md:mt-3 text-xs md:text-sm amount-text",
          children: "Amount"
        }), /*#__PURE__*/_jsx(Input, {
          "aria-label": "Donation amount for all projects ",
          id: "input-donationamount",
          min: "0",
          value: "",
          type: "number",
          className: "w-16 md:w-24"
        }), /*#__PURE__*/_jsx(PayoutTokenDropdown, {
          setSelectedPayoutToken: () => {
            {
              /*Do nothing when cart is empty*/
            }
          },
          payoutTokenOptions: [],
          balanceWarning: false
        }), /*#__PURE__*/_jsx(Button, {
          type: "button",
          disabled: true,
          $variant: "outline",
          className: "text-sm px-0 md:px-4 py-2 text-blue-200 border-0",
          children: "Apply to all"
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "mt-4",
      children: /*#__PURE__*/_jsx("p", {
        className: "text-grey-500",
        children: "Cart is empty."
      })
    })]
  });
}